"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@react-google-maps/api");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const Map_mappers_1 = require("./Map.mappers");
const MapClustererContext_1 = require("./MapClustererContext");
const MapPinLayout_1 = __importDefault(require("./MapPinLayout"));
const MapPinView_1 = require("./MapPinView");
function MapPin(props) {
    const { coordinates, object, children, initialSelected = false, viewRef, onClick, onInit, onClickOnSelectedPin, className, activePinColor, } = props;
    const map = (0, api_1.useGoogleMap)();
    const { clusterer } = (0, MapClustererContext_1.useMapClusterer)();
    const pinDivRef = (0, react_1.useRef)(null);
    const [selected, setSelected] = (0, react_1.useState)(initialSelected);
    const [view, setView] = (0, react_1.useState)(null);
    const [mapEl, setMapEl] = (0, react_1.useState)(null);
    if (viewRef) {
        viewRef.current = view;
    }
    (0, react_1.useEffect)(() => {
        if (!map)
            return;
        const mapSetup = clusterer ? undefined : map;
        const pinView = new MapPinView_1.MapPinView(object, (0, Map_mappers_1.mapCoordinatesToLatLng)(coordinates), mapSetup);
        pinView.onAdd = () => setMapEl(pinView.getPanes().overlayMouseTarget);
        pinView.onRemove = () => setMapEl(null);
        pinView.draw = () => {
            const div = pinDivRef.current;
            if (div) {
                const canvasProjection = pinView.getProjection();
                Object.assign(div.style, (0, Map_mappers_1.coordinatesToCanvasPosition)(canvasProjection, coordinates));
            }
        };
        if (clusterer) {
            clusterer.addMarker(pinView, false);
        }
        else {
            pinView.setMap(map);
        }
        setView(pinView);
        return function cleanupPin() {
            setView(null);
            if (clusterer) {
                clusterer.removeMarker(pinView, false);
            }
            else {
                pinView.setMap(null);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, clusterer, coordinates.longitude, coordinates.latitude]);
    (0, react_1.useEffect)(function selectPinEffect() {
        if (!view)
            return;
        const { remove: cleanSelectSubscribe } = google.maps.event.addListener(view, 'select', () => {
            setSelected(true);
        });
        const { remove: cleanDeselectSubscribe } = google.maps.event.addListener(view, 'deselect', () => {
            setSelected(false);
        });
        return function cleanupSubscription() {
            try {
                cleanSelectSubscribe();
                cleanDeselectSubscribe();
            }
            catch (e) { }
        };
    }, [view]);
    (0, react_1.useEffect)(() => {
        if (mapEl) {
            // Stops events on the element from bubbling up to the map
            google.maps.OverlayView.preventMapHitsAndGesturesFrom(mapEl);
        }
    }, [mapEl]);
    (0, react_1.useEffect)(function onInitEffect() {
        if (view) {
            onInit === null || onInit === void 0 ? void 0 : onInit(object, view);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [view]);
    const onClickHandler = (0, react_1.useCallback)(() => {
        if (view) {
            onClick === null || onClick === void 0 ? void 0 : onClick(object, view);
            if (selected) {
                onClickOnSelectedPin === null || onClickOnSelectedPin === void 0 ? void 0 : onClickOnSelectedPin();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClick, view, onClickOnSelectedPin]);
    return mapEl
        ? (0, react_dom_1.createPortal)(react_1.default.createElement(MapPinLayout_1.default, { ref: pinDivRef, selected: selected, onClick: onClickHandler, className: className, activePinColor: activePinColor }, children), mapEl)
        : null;
}
exports.default = MapPin;
//# sourceMappingURL=MapPin.js.map